module.exports = "/_next/static/images/AggregationProfileAPI@2x-12d4d0d786593307c0f55fe93f869b97.png";